import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { Panel } from '@layout';
import { Button } from '@atoms';
import { PageTemplate, OrganizationInformationForm } from '@templates';
import messages from './messages';

export default class OrganizationEditPage extends PureComponent {
  static propTypes = {
    isSubmitting: PropTypes.bool,
    updateOrganization: PropTypes.func.isRequired,
  };

  static defaultProps = {
    isSubmitting: false,
  };

  componentWillMount() {
    const {
      path,
      goToOrganizations,
      organizationsEditForm: { id },
    } = this.props;

    if (path === '/organization/edit/:id') {
      !id && goToOrganizations();
    }

    this.props.loadRules();
    this.props.loadAllOrganizations();
    this.props.getIntroMessages({
      include: 'organization',
      where: { or: [{ organizationId: id }, { organizationId: null }] },
    });
  }

  updateOrganizationHandler = () =>
    !this.props.isSubmitting && this.props.updateOrganization();

  render() {
    const { goToOrganizations, isSubmitting } = this.props;

    return (
      <PageTemplate title={<FormattedMessage {...messages.title} />}>
        <Panel>
          <OrganizationInformationForm editMode />
          <Button
            onClick={this.updateOrganizationHandler}
            loading={isSubmitting}
            primary
            style={{ marginRight: '1rem' }}
          >
            <FormattedMessage {...messages.update} />
          </Button>
          <Button onClick={goToOrganizations}>
            <FormattedMessage {...messages.cancel} />
          </Button>
        </Panel>
      </PageTemplate>
    );
  }
}



// WEBPACK FOOTER //
// ./components/pages/OrganizationEditPage/OrganizationEditPage.js